$(document).ready(function () {
    $(".icon-read-more").click(function () {
        $(".additioal_block_box").slideDown(); // Show all
        $(".icon-read-more").hide();
        $(".icon-read-less").show();
    });

    $(".icon-read-less").click(function () {
        $(".additioal_block_box").slice(4).slideUp(); // Hide after first 4
        $(".icon-read-less").hide();
        $(".icon-read-more").show();
    });
});